import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';

import PageTitle from 'components/common/PageTitle';

const styles = () => ({
  pageTitle: {
    marginBottom: 16
  },
});

const ConnectedOrdersToolbar = ({
  classes,
}) => (
  <Toolbar disableGutters>
    <Grid
      container
      justify="space-between"
      alignItems="flex-start"
      spacing={24}
      wrap="nowrap"
    >
      <Grid item>
        <PageTitle
          className={classes.pageTitle}
          text="Connected orders"
          goBack
          variant="button"
        />
      </Grid>
    </Grid>
  </Toolbar>
);

ConnectedOrdersToolbar.propTypes = {
  classes: PropTypes.shape({
    pageTitle: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(ConnectedOrdersToolbar);



// WEBPACK FOOTER //
// ./src/components/workflow/ConnectedOrdersToolbar/ConnectedOrdersToolbar.js